import { cn } from '@/utils';

const BrainGym = (props: React.SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
      {...rest}
    >
      <path
        d="M12.7517 16.4345C12.7517 16.4345 5.5237 16.5453 4.82129 16.4345C4.11889 16.3238 1.45421 15.1165 2.09939 12.3577C2.32276 11.5546 2.78621 10.8388 3.42778 10.3066C4.06936 9.7744 4.85832 9.45114 5.68886 9.38C5.32615 8.91547 5.12911 8.34306 5.12911 7.7537C5.12911 7.16435 5.32615 6.59194 5.68886 6.12741C5.97003 5.73986 6.33663 5.42218 6.76036 5.19923C7.18409 4.97628 7.65359 4.85407 8.13224 4.84184C8.61089 4.82961 9.08579 4.92768 9.52035 5.1287C9.95491 5.32972 10.3375 5.62808 10.638 6.00077C11.2004 6.66037 11.6101 7.43617 11.838 8.27244"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9946 6.00353C11.3966 5.3661 11.9762 4.86014 12.6619 4.5476C13.3477 4.23506 14.1099 4.12954 14.8547 4.24429C15.5779 4.39186 16.2287 4.78266 16.6989 5.35162C17.1691 5.92057 17.4302 6.63352 17.439 7.37158"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.354 8.71277C15.886 8.01908 16.6638 7.55578 17.5272 7.41841C18.3906 7.28104 19.2739 7.48001 19.9949 7.97433C22.7058 9.7428 20.7194 12.5977 20.7194 12.5977C20.3544 13.1317 19.8796 13.5817 19.3268 13.9177C18.774 14.2537 18.156 14.4678 17.5139 14.546"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.9761 20.1656C16.9761 20.1656 21.1295 20.7498 21.891 17.7371C22.1067 16.9213 21.9985 16.0537 21.589 15.3158C21.1796 14.578 20.5005 14.027 19.6941 13.7783"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.72607 11.8368C9.09423 11.4263 9.5691 11.126 10.0977 10.9694C10.6264 10.8128 11.1881 10.8059 11.7204 10.9496C13.3652 11.5606 13.2618 13.7382 13.2618 13.7382"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BrainGym;
